var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "close",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7488 11.4064L1.99614 0.653693C1.54053 0.19808 0.814433 0.185492 0.374354 0.625571C-0.0657256 1.06565 -0.0531368 1.79175 0.402475 2.24736L11.1552 13.0001L0.402516 23.7527C-0.0530961 24.2083 -0.0656871 24.9344 0.374392 25.3745C0.814471 25.8146 1.54057 25.802 1.99618 25.3464L12.7488 14.5937L23.5013 25.3462C23.9569 25.8018 24.683 25.8144 25.1231 25.3743C25.5632 24.9342 25.5506 24.2081 25.095 23.7525L14.3425 13.0001L25.095 2.24757C25.5506 1.79196 25.5632 1.06586 25.1231 0.625784C24.683 0.185705 23.9569 0.198294 23.5013 0.653906L12.7488 11.4064Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.5612ed5702c3b1469300cda90408f0a1.svg";
export { ForwardRef as ReactComponent };